<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="剧本编码前缀(剧本名称1~5位首字母)" prop="scriptCodePrefix" >
        <a-input v-model="form.scriptCodePrefix" placeholder="剧本编码前缀(剧本名称1~5位首字母)" />
      </a-form-model-item>
      <a-form-model-item label="生成个数" prop="generateNum" >
        <a-input-number v-model="form.generateNum" :min="0" :step="1" :precision="0" placeholder="请输入生成个数" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            生成
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'ExportBatchGenerateScriptCodeForm',
  props: {
  },
  components: {},
  data () {
    return {
      submitLoading: false,
      // 表单参数
      form: {
        scriptId: null,
        scriptCodePrefix: null,
        generateNum: null
      },
      open: false,
      rules: {
        scriptCodePrefix: [
          { required: true, message: '剧本编码前缀(剧本名称1~5位首字母)', trigger: 'blur' }
        ],
        generateNum: [
          { required: true, message: '生成个数不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        scriptId: null,
        scriptCodePrefix: null,
        generateNum: null
      }
    },
    handle (row) {
      this.reset()
      this.form.scriptId = row.scriptId
      this.open = true
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          var that = this
          this.submitLoading = true
          that.download('played/script/activation/exportBatchGenerateScriptCode', {
            ...that.form
          }, `剧本编码及二维码${parseTime(new Date())}.xlsx`)
          this.open = false
          this.submitLoading = false
        } else {
          return false
        }
      })
    }
  }
}
</script>
